import { DvmModule } from '@3ddv/ngx-dvm-internal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MultiselectionToastComponent } from '@core/components/multiselection-toast/multiselection-toast.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxSliderModule } from 'ngx-slider-v2';
import { SelectSeatRoutingModule } from './select-seat-routing.module';
import { SelectSeatComponent } from './select-seat.component';
import { CartComponent } from './sidebar/cart/cart.component';
import { CartAccordionComponent } from './sidebar/cart/partials/cart-accordion/cart-accordion.component';
import { CartHeaderComponent } from './sidebar/cart/partials/cart-header/cart-header.component';
import { CartSeatItemComponent } from './sidebar/cart/partials/cart-seat-item/cart-seat-item.component';
import { CartSectionItemComponent } from './sidebar/cart/partials/cart-section-item/cart-section-item.component';
import { FiltersComponent } from './sidebar/filters/filters.component';
import { AccesibleSeatingComponent } from './sidebar/filters/partials/accesible-seating/accesible-seating.component';
import { BestSeatsComponent } from './sidebar/filters/partials/best-seats/best-seats.component';
import { PriceRangeComponent } from './sidebar/filters/partials/price-range/price-range.component';
import { SelectTicketsComponent } from './sidebar/filters/partials/select-tickets/select-tickets.component';
import { SelectorComponent } from './sidebar/filters/partials/selector/selector.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TotalComponent } from './sidebar/total/total.component';
import { MapLoaderComponent } from './viewer/map-loader/map-loader.component';
import { MapControlsComponent } from './viewer/topbar/map-controls/map-controls.component';
import { TopbarComponent } from './viewer/topbar/topbar.component';
import { UpgradesComponent } from './viewer/topbar/upgrades/upgrades.component';
import { ViewerComponent } from './viewer/viewer.component';

@NgModule({
  declarations: [
    SelectSeatComponent,
    SidebarComponent,
    ViewerComponent,
    MapLoaderComponent,
    TopbarComponent,
    UpgradesComponent,
    MapControlsComponent,
    FiltersComponent,
    TotalComponent,
    CartComponent,
    CartHeaderComponent,
    CartSectionItemComponent,
    CartSeatItemComponent,
    CartAccordionComponent,
    SelectTicketsComponent,
    PriceRangeComponent,
    SelectorComponent,
    AccesibleSeatingComponent,
    BestSeatsComponent,
    MultiselectionToastComponent,
  ],
  imports: [
    CommonModule,
    DvmModule,
    FormsModule,
    NgxSliderModule,
    SelectSeatRoutingModule,
    TooltipModule,
  ],
})
export class SelectSeatModule {}
